'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/** Sets `overflow: hidden` on the html body element
 * @param [isActive=true] defaults to `true` */
export default function useBlockBodyScrolling(t0) {
  const $ = _c(3);
  const isActive = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== isActive) {
    t1 = () => {
      if (isActive) {
        document.body.classList.add("overflow-hidden");
      }
      return _temp;
    };
    t2 = [isActive];
    $[0] = isActive;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
}
function _temp() {
  document.body.classList.remove("overflow-hidden");
}